import { Routes } from '@angular/router';
import { ROUTE_NAMES } from '@constants';
import { i18nResolver, userBeanResolver } from 'src/app/core/resolvers';

export const searchRoutes: Routes = [
  {
    path: 'search',
    title: 'WEB_COMMUNITY_SEARCH',
    resolve: {
      agorai18n: i18nResolver,
      userBean: userBeanResolver,
    },
    loadComponent: () =>
      import('./pages/search.component').then((m) => m.SearchComponent),
    data: { navigationRoute: ROUTE_NAMES.SEARCH },
  },
];
